import { render } from "./WorkspaceHeader.vue?vue&type=template&id=4e336a17"
import script from "./WorkspaceHeader.vue?vue&type=script&lang=js"
export * from "./WorkspaceHeader.vue?vue&type=script&lang=js"

import "./WorkspaceHeader.vue?vue&type=style&index=0&id=4e336a17&lang=css"

import exportComponent from "/var/www/html/clientwebview/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__